require('./new.jade')
require('./email.jade')
require('./email_success.jade')
require('./edit.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/form/form-module')
require('../components/auth/auth-module')
require('../components/term/term-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/remote-api/remote-api-module')
require('../components/account/account-module.coffee')
# Load Css
require('../../../sass/web/html/_registration.scss')
require('../../../sass/web/html/_account_setting.scss')

RegistrationNewCtrl = require('./new-controller')
RegistrationEmailCtrl = require('./email-controller')
RegistrationEmailSuccessCtrl = require('./email-success-controller')
RegistrationEditCtrl = require('./edit-controller')
RegistrationService = require('./registration-service')
CountryService = require('./country-service')
PrefectureService = require('./prefecture-service')
GenderService = require('./gender-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-form'
  'gnp-auth'
  'gnp-term'
  'gnp-common-wrapper'
  'gnp-error-handler'
  'gnp-remote-api'
  'gnp-account'
]
angular.module 'gnp-app-registration', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider
      .when '/registration/new/:token',
        templateUrl: 'web/registration/new.jade'
        controller: 'RegistrationNewCtrl'
        title: '_REGISTRATION.NEW.TITLE'
      .when '/registration/email',
        templateUrl: 'web/registration/email.jade'
        controller: 'RegistrationEmailCtrl'
        title: '_REGISTRATION.EMAIL.TITLE'
      .when '/registration/email/success',
        templateUrl: 'web/registration/email_success.jade'
        controller: 'RegistrationEmailSuccessCtrl'
        title: '_REGISTRATION.EMAIL_SUCCESS.TITLE'
      .when '/registration/edit',
        templateUrl: 'web/registration/edit.jade'
        controller: 'RegistrationEditCtrl'
        resolve:
          account: ['RegistrationService', (RegistrationService) ->
            RegistrationService.get()
          ]
          confirmationStatus: ['AccountService', (AccountService) ->
            AccountService.getUserInfo().then (data) -> data.email_confirmed
          ]
        title: '_REGISTRATION.EDIT.TITLE'
        permission:
          signInRequired: true
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'RegistrationNewCtrl', RegistrationNewCtrl
  .controller 'RegistrationEmailCtrl', RegistrationEmailCtrl
  .controller 'RegistrationEmailSuccessCtrl', RegistrationEmailSuccessCtrl
  .controller 'RegistrationEditCtrl', RegistrationEditCtrl
  .factory 'RegistrationService', RegistrationService
  .factory 'CountryService', CountryService
  .factory 'PrefectureService', PrefectureService
  .factory 'GenderService', GenderService




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/registration-module.coffee